import { z } from 'zod';
import { AcademicYear } from '@triedge/domain-core/types';
import { UnixTimestamp } from '@triedge/domain-core/types';
import { TransactionStatusSchema, TransactionTypeSchema } from '../types/enums';

export const PortalTransactionSchema = z.object({
  id: z.string(),
  familyId: z.string(),
  studentId: z.string().nullable().optional(),
  academicYear: AcademicYear,
  type: TransactionTypeSchema,
  status: TransactionStatusSchema,
  amount: z.number(),
  transactionDate: UnixTimestamp,
  referenceCode: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
});
export type PortalTransaction = z.infer<typeof PortalTransactionSchema>;
